module.exports = __webpack_public_path__ + "logo-icon.png?abb4e99e55d5bba31d6e5fbc9139e8ae";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-icon.png
// module id = 236
// module chunks = 0